import React, { FC } from 'react';
import CMPImage from 'components/global/image';
interface Props {
  wh?: number;
}
const ArchitectureIcon: FC<Props> = ({ wh }) => {
  return (
    <CMPImage
      asset={{
        src: `${process.env.PUBLIC_URL}/images/professions/Architecture.png`,
        alt: 'Architecture',
      }}
      width={wh || 64}
      height={wh || 64}
    />
  );
};

export default ArchitectureIcon;
